import Icon from "@/components/Icon";

/**
 * Functional component to replace the deselect icon in vue-select.
 */
export default {
    functional: true,
    render: (createElement) => createElement(Icon, { props: { name: "x", color: "var(--medium-contrast)" } }),
};
